import { createBrowserHistory } from 'history'
interface ErrorHandlerRedirectProps {
  to: string
  children: React.ReactElement
}

export const ErrorHandlerRedirect = ({
  to = '',
  children,
}: ErrorHandlerRedirectProps) => {
  const history = createBrowserHistory()
  const current = location.pathname
  if (to && current !== to) {
    history.push(to)
  } else {
    const list = localStorage.getItem('navigationList')
    const item = list && list.split(',')[0]
    const path = item && item !== current ? item : '/'
    const navigationListError = localStorage.getItem('navigationListError')
      ? localStorage.getItem('navigationListError').split(',')
      : []
    navigationListError.push(current)
    localStorage.setItem('navigationListError', navigationListError.join())
    history.push(path, { snackbar: true })
  }
  return children
}
